import client from "../index.js";
import { GET_SETTINGS } from "./query.js";
import { CREATE_SETTING, UPDATE_SETTING } from "./mutation.js";
import { createReferenceMemo } from "../referenceMemo.js";

// Settings are reference data fetched by many components with identical
// inputs (categories, statuses, states, file types). Memoize per-input so a
// page mount issues each distinct settings query at most once per session;
// mutations below invalidate the memo.
const settingsMemo = createReferenceMemo();

export const apiGetSettings = (input) =>
  settingsMemo.run(JSON.stringify(input || {}), () =>
    client
      .query({ query: GET_SETTINGS, variables: { input }, fetchPolicy: "no-cache" })
      .then((res) => res.data.settings)
  );

export const apiCreateSetting = (input) =>
  client
    .mutate({ mutation: CREATE_SETTING, variables: { input }, fetchPolicy: "no-cache" })
    .then((res) => {
      settingsMemo.clear();
      return res.data.createSetting.setting;
    });

export const apiUpdateSetting = (input) =>
  client
    .mutate({ mutation: UPDATE_SETTING, variables: { input }, fetchPolicy: "no-cache" })
    .then((res) => {
      settingsMemo.clear();
      return res.data.updateSetting.setting;
    });
